import React, { Component } from "react";
import PropTypes from "prop-types";
import SuggestionBubble from "./SuggestionBubble";
import SuggestionSquare from "./SuggestionSquare";
import Chevron from "../resources/Chevron.png";
const SuggestionBubbles = props => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "suggestion-row"
  }, props.suggestions.map((suggestion, index) => {
    const condition = props.suggestions.length > 2 ? index % 2 === 1 : true;
    if (condition) return null;
    return /*#__PURE__*/React.createElement(SuggestionBubble, {
      className: suggestion === props.current ? "active" : "",
      suggestion: suggestion,
      key: index,
      onClick: () => {
        props.onSuggestionClick(suggestion);
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "suggestion-row"
  }, props.suggestions.map((suggestion, index) => {
    const condition = props.suggestions.length > 2 ? index % 2 === 0 : false;
    if (condition) return null;
    return /*#__PURE__*/React.createElement(SuggestionBubble, {
      className: suggestion === props.current ? "active" : "",
      suggestion: suggestion,
      key: index,
      onClick: () => {
        props.onSuggestionClick(suggestion);
      }
    });
  })));
};
SuggestionBubbles.propTypes = {
  current: PropTypes.string,
  suggestions: PropTypes.array,
  onSuggestionClick: PropTypes.func
};
const SuggestionSquares = props => {
  const currentOptions = props.richContent.content.deliveryOptions ? props.richContent.content.deliveryOptions : [props.richContent.content.confirmDeliveryOptions];
  return currentOptions.map((option, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "suggestion-row",
      key: index
    }, /*#__PURE__*/React.createElement(SuggestionSquare, {
      option: option,
      key: index,
      onClick: () => {
        props.onRichContentClick(option);
      }
    }));
  });
};
class ChatSuggestions extends Component {
  constructor(props) {
    super(props);
    this.updateChevrons = this.updateChevrons.bind(this);
  }
  toggleChevrons(timeout = 200) {
    setTimeout(() => {
      const container = document.getElementById("suggestion-container");
      const wasScrollable = this.isScrollable || false;
      this.isScrollable = false;
      if (container) {
        this.isScrollable = container.scrollWidth > container.offsetWidth;
        if (this.isScrollable) {
          this.updateChevrons(container);
        }
        if (!wasScrollable && this.isScrollable || wasScrollable && !this.isScrollable) {
          this.forceUpdate();
        }
      }
    }, timeout);
  }
  componentDidMount() {
    this.toggleChevrons();
    const container = document.getElementById("suggestion-container");
    container.addEventListener("scroll", this.updateChevrons(container));
  }
  componentDidUpdate() {
    this.toggleChevrons();
  }
  updateChevrons(container) {
    this.isScrollable = container.scrollLeft > 0 ? container.scrollLeft + container.offsetWidth < container.scrollWidth ? "both" : "left" : container.offsetWidth < container.scrollWidth ? "right" : "none";
    this.forceUpdate();
  }
  scrollContainer(direction) {
    const container = document.getElementById("suggestion-container");
    if (direction === "left") {
      container.scrollLeft -= container.offsetWidth;
    } else if (direction === "right") {
      container.scrollLeft += container.offsetWidth;
    }
  }
  render() {
    let buClass = this.props.businessUnit === 2 ? "dark-red-gradient" : "dark-blue-gradient";
    buClass += " mydpd-version";
    const isRichContent = this.props.richContent && (this.props.richContent.type === "options" || this.props.richContent.type === "confirm-options");
    return /*#__PURE__*/React.createElement("div", {
      id: "chat-suggestions",
      className: buClass
    }, /*#__PURE__*/React.createElement("div", {
      id: "suggestion-statement"
    }, this.isScrollable === "left" || this.isScrollable === "both" ? /*#__PURE__*/React.createElement("img", {
      alt: "Scroll Rich Content Left",
      src: Chevron,
      className: "suggestion-scroller-left",
      onClick: () => {
        this.scrollContainer("left");
      }
    }) : null, !isRichContent && this.props.suggestions.length > 0 ? "" : "", this.isScrollable === "right" || this.isScrollable === "both" ? /*#__PURE__*/React.createElement("img", {
      alt: "Scroll Rich Content Right",
      src: Chevron,
      className: "suggestion-scroller-right",
      onClick: () => {
        this.scrollContainer("right");
      }
    }) : null), /*#__PURE__*/React.createElement("div", {
      id: "suggestion-container"
    }, isRichContent ? /*#__PURE__*/React.createElement(SuggestionSquares, {
      richContent: this.props.richContent,
      onRichContentClick: this.props.onRichContentClick
    }) : /*#__PURE__*/React.createElement(SuggestionBubbles, {
      suggestions: this.props.suggestions,
      onSuggestionClick: this.props.onSuggestionClick
    })));
  }
}
ChatSuggestions.propTypes = {
  businessUnit: PropTypes.number,
  richContent: PropTypes.object,
  suggestions: PropTypes.array,
  onRichContentClick: PropTypes.func,
  onSuggestionClick: PropTypes.func
};
export default ChatSuggestions;